import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "./pages/LandingPage";
import AnalysisResult from "./pages/AnalysisResult";
import CoupleQuestionnaire from "./pages/CoupleQuestionnaire";
import { AdminGuard, AdminLogin } from "./pages/admin/AdminLayout";
import AdminDashboard, { AdminLeads } from "./pages/admin/AdminDashboard";
import AdminAnalysisDetail from "./pages/admin/AdminAnalysisDetail";
import AdminLibrary from "./pages/admin/AdminLibrary";
import AdminFailedReports from "./pages/admin/AdminFailedReports";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import ChatGPTVsVowze from "./pages/ChatGPTVsVowze";
import SampleReport from "./pages/SampleReport";

// Everything that used to lead to /questionnaire/individual or /analyze
// is now routed to the couple wedding questionnaire — the only product.
function CoupleRedirect() {
    return <Navigate to="/questionnaire/couple" replace />;
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/analyze" element={<CoupleRedirect />} />
                    <Route path="/questionnaire/individual" element={<CoupleRedirect />} />
                    <Route path="/questionnaire/couple" element={<CoupleQuestionnaire />} />
                    <Route path="/result/:id" element={<AnalysisResult />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/chatgpt-vs-vowze" element={<ChatGPTVsVowze />} />
                    <Route path="/sample-report" element={<SampleReport />} />

                    {/* Admin */}
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route element={<AdminGuard />}>
                        <Route path="/admin" element={<AdminDashboard />} />
                        <Route path="/admin/leads" element={<AdminLeads />} />
                        <Route path="/admin/library" element={<AdminLibrary />} />
                        <Route path="/admin/failed-reports" element={<AdminFailedReports />} />
                        <Route path="/admin/analysis/:id" element={<AdminAnalysisDetail />} />
                    </Route>
                </Routes>
            </BrowserRouter>
            <Toaster
                position="top-center"
                richColors
                toastOptions={{
                    style: {
                        fontFamily: "Inter, system-ui, sans-serif",
                        borderRadius: "9999px",
                    },
                }}
            />
        </div>
    );
}

export default App;
